module.exports = "<div class=\"lowy-modal\" *ngIf=\"visible\" [ngClass]=\"{opening: isOpen, closing: !isOpen}\">\n  <div class=\"inner\" (lowyClickOutside)=\"close($event)\" [ngClass]=\"{tall: tall}\">\n    <div><ng-content></ng-content></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/modal.component.html
// module id = ./src/app/components/modal/modal.component.html
// module chunks = main